export default "__VITE_ASSET__$X5Tay5A__"